// WholesaleOS login page — standalone bundle (vanilla JS).
//
// Renders the login form and POSTs to /public/login. On success the server
// sets the auth cookie and returns a redirect URL; we follow it.

(function () {
  'use strict';

  var cfg = window.WholesaleOSBoot || {};
  var root = document.getElementById('wholesaleos-root');
  if (!root) { return; }

  // Preserve a post-login return target from ?return=…
  var urlParams = new URLSearchParams(window.location.search);
  var returnTo = urlParams.get('return') || '';

  root.innerHTML =
    '<section class="wos-auth-card">' +
      '<h1>Sign in</h1>' +
      '<p class="wos-auth-sub">Welcome back.</p>' +
      '<form id="wos-login-form" novalidate>' +
        '<label for="wos-user">Email or username</label>' +
        '<input id="wos-user" name="user" type="text" autocomplete="username" autofocus required>' +

        '<label for="wos-pw">Password</label>' +
        '<input id="wos-pw" name="password" type="password" autocomplete="current-password" required>' +

        '<label class="wos-checkbox"><input type="checkbox" name="remember"> Keep me signed in</label>' +

        '<button type="submit" class="wos-btn wos-btn-primary wos-btn-wide" id="wos-login-go">Sign in</button>' +

        '<p class="wos-auth-alt">' +
          '<a href="' + escapeAttr(cfg.landing_url || '/') + '">← Back</a>' +
          '<a href="/forgot-password">Forgot password?</a>' +
        '</p>' +
        '<p class="wos-auth-msg" id="wos-msg" role="status" aria-live="polite"></p>' +
      '</form>' +
    '</section>';

  var form = document.getElementById('wos-login-form');
  var msg  = document.getElementById('wos-msg');
  var btn  = document.getElementById('wos-login-go');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var data = new FormData(form);
    var body = {
      user:     data.get('user'),
      password: data.get('password'),
      remember: form.querySelector('[name="remember"]').checked,
    };
    msg.className = 'wos-auth-msg';
    msg.textContent = 'Signing in…';
    btn.disabled = true;

    fetch((cfg.apiBase || '/wp-json/wholesaleos/v1/') + 'public/login', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          msg.className = 'wos-auth-msg wos-auth-msg--error';
          msg.textContent = (res.json && (res.json.message || res.json.code)) || 'Sign-in failed.';
          btn.disabled = false;
          return;
        }
        var target = returnTo || (res.json && res.json.redirect) || '/app';
        // Bounce away — server has set the auth cookie.
        window.location.href = target;
      })
      .catch(function (err) {
        msg.className = 'wos-auth-msg wos-auth-msg--error';
        msg.textContent = (err && err.message) || 'Sign-in failed.';
        btn.disabled = false;
      });
  });

  function escapeAttr(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;','\'':'&#39;' })[c]; }); }
})();
